import { Injectable, inject } from '@angular/core';
import { Observable, ReplaySubject, Subject } from 'rxjs';
import { ContractsConfig, ContractType } from '../../models/db-models';
import { DbService } from './db.service';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ConfigService {
  private db = inject(DbService);
  private _contractsConfig$: Subject<ContractsConfig> = new ReplaySubject(1);
  private initialized = false;

  get contractsConfig$(): Observable<ContractsConfig> {
    if (!this.initialized) {
      this.init();
    }
    return this._contractsConfig$;
  }

  private init() {
    if (this.initialized) {
      return;
    }
    this.initialized = true;
    this.db.getContractsConfig().subscribe({
      next: (contractsConfig) => {
        this._contractsConfig$.next(contractsConfig);
      },
      error: (error) => {
        // Silently handle permission errors - config is only needed for admin operations
      }
    });
  }

  getContractTypes(): Observable<ContractType[]> {
    return this.contractsConfig$.pipe(map((contractsConfig) => contractsConfig.types));  
  }

}
